import { ModalActionButtons, ModalTitle } from '../../ModalComponents'

/* eslint-disable import/no-internal-modules */
import Modal from '../../../../../../components/reactModal'
import Icon from '@insided/deprecated-preact-components/assets'
import Textarea from '@insided/deprecated-control/ui-components/Textarea'

interface Props {
  modalTitle?: string
  modalTitleImage?: string
  closeModal: () => void
  isOpen: boolean
  username?: string
  body?: string | undefined
  titleValidationError?: string
  contentValidationError?: string
  onContentChange: (value: string) => void
  onSubmit: () => void
  onTextareaFocus: (e?: MouseEvent | FocusEvent) => void
  isLoading: boolean
  errorFields?: string []
}

const CreateIntercomConversationModal = (props: Props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    username,
    body,
    onContentChange,
    onTextareaFocus,
    isLoading,
     errorFields
  } = props

  const errorMessage = 'Please fill in the required field'
  return (
    <Modal isOpen={isOpen} onClose={() => closeModal()}>
      <div className='integration__create_intercom_conversation_modal integration__escalate_modal'>
        <ModalTitle title='Create an Intercom conversation' imageName='intercom' />
        <div className='modal-description'>
          <div className='modal-user-email-field modal-data'>
            <label>User</label>
            <div>{username}</div>
          </div>
          <label>Body</label>
          <div className='modal-post-body-field modal-data'>
            <Textarea
              verticalResize
              adjustHeight
              onContentChange={(value: string) => onContentChange(value)}
              // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='modal-post-content'
              value={body?.replace(/<[^>]*>?/gm, ' ') ?? ''}
              newStyle
              onTextareaFocus={() => onTextareaFocus()}
              error={errorFields?.includes('body')}
            />
            {errorFields?.includes('body') && <div className='error-message-container'>
              <div><Icon customClass='icon-warning' icon='warning' /></div>
              <div className='error-message-text'>{errorMessage}</div>
            </div>}
          </div>
        </div>
        <ModalActionButtons onSubmit={() => onSubmit()} isLoading={isLoading} closeModal={() => closeModal()} />
      </div>
    </Modal>
  )
}

export default CreateIntercomConversationModal
